import { PAY_LINKS } from "../constants"

const breadcrumbConfig = [
  {
    title: "Account",
    action: `${PAY_LINKS.account}`,
  },
  {
    title: "Payment",
    action: `${PAY_LINKS.payment}`,
  },
  {
    title: "Submit",
    action: `${PAY_LINKS.submit}`,
  },
]

export { breadcrumbConfig as default }



// WEBPACK FOOTER //
// ./assets/payment/components/breadcrumbConfig.js